import { Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useTranslation } from "react-i18next";

export const MissingMixPlaceholder = ({
  source,
  width = 250,
}: {
  source: string;
  width?: number;
}) => {
  const { t } = useTenantTranslation();
  const { t: rawT } = useTranslation();

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      width={width}
      gap={1}
      sx={{ opacity: 0.4 }}
    >
      <Typography variant="h5" textAlign="center">
        {rawT(source)}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t("noData")}
      </Typography>
    </Stack>
  );
};
